import React, {useState, useEffect} from "react"
import { graphql } from "gatsby"

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";

import '../css/prefooter.css';

import LeftArrow from '../images/left-arrow.png';
import RightArrow from '../images/right-arrow.png';

import {faCaretLeft } from "@fortawesome/free-solid-svg-icons";
import {faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


function CustomPrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={`previous ${className}`} onClick={onClick}>
    <FontAwesomeIcon icon={faCaretLeft} />
    </div>
    // <img 
    //   className={className} 
    //   style={{ ...style }}
    //   src={LeftArrow}
    //   onClick={onClick}
    // />
  );
}

function CustomNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={`next ${className}`} onClick={onClick}>
    <FontAwesomeIcon icon={faCaretRight} />
    </div>
    // <img 
    //   className={className} 
    //   style={{ ...style }}
    //   src={RightArrow}
    //   onClick={onClick}
    // />
  );
}

const PreFooter = ({ logos }) => { 

  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    // Check if the logos are loaded
    if (logos && logos.length > 0) {
      setIsClient(true);
    }
  }, [logos]);
  


  if (!isClient) {
    // Prevent rendering during server-side rendering
    return null
  }

  var settings = {
    arrows:true,
    dots: false,
    infinite: true,
    autoplaySpeed: 8000,
    autoplay:true,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />
  };


  return (
    <div className="prefooter container maincopy">
    <h2>Professional Partnerships</h2>
      <Slider {...settings}>
      {logos.map((item, index) => (
        <div key={index}>
          <img className="prefooter-logo" src={item.logo.localFile.publicURL} alt={item.logo.altText} />
        </div>
      ))}
      </Slider>
    </div>
  )
}

export default PreFooter